import { render, staticRenderFns } from "./Payslips.vue?vue&type=template&id=5ba836cd&scoped=true"
import script from "./Payslips.vue?vue&type=script&lang=js"
export * from "./Payslips.vue?vue&type=script&lang=js"
import style0 from "./Payslips.vue?vue&type=style&index=0&id=5ba836cd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba836cd",
  null
  
)

export default component.exports